export default __webpack_public_path__ + "static/media/pulse-outline.f9f861e0.svg";